import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';

import { Container, Form, FormGroup, Alert } from 'reactstrap';
import { toast, ToastContainer } from 'react-toastify';

import Button from '../../components/button/button';
import Input from '../../components/input/input';

import { logout, login } from '../../../modules/user_api';
import './login.css';

import { withWhiteLabelContext } from 'react-whitelabel';

class Login extends Component {
  constructor(props) {
    super(props);
    this.logoStyle = {
      width: '200px',
      marginLeft: '16px',
      marginTop: '10px',
    };
    this.state = {
      username: '',
      password: '',
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    logout();
  }

  async submitLogin() {
    const { dispatch } = this.props;
    dispatch(login(this.state.username, this.state.password));
  }

  handleKeyPress(event) {
    if (event.key === 'Enter') {
      this.submitLogin();
    }
  }

  scrapeProof(email) {
    return (
      <span>
        {email.split('').map((letter) => (
          <span>{letter}</span>
        ))}
      </span>
    );
  }
  componentDidUpdate(prevProps) {
    const { errorMessage } = this.props;
    if (errorMessage && !prevProps.errorMessage) {
      toast.error(errorMessage, { position: 'top-center' });
    }
  }

  render() {
    const { token } = this.props;
    if (token) {
      return <Redirect to="/" />;
    }

    const { logo, platform } = this.props.label;
    return (
      <Container className="login-card text-center">
        <ToastContainer autoClose={5000} />
        <img alt="Timocco Logo" style={this.logoStyle} src={logo} className="Login-logo" />
        <p className="login-card-text">Log in to your account.</p>
        <Form className="login-form" style={{ margin: '0 auto' }}>
          <Input
            className="login-input"
            label="Username"
            name="username"
            value={this.state.username}
            onChange={(username) => {
              this.setState({ username });
            }}
            onKeyPress={this.handleKeyPress}
          />
          <Input
            className="login-input"
            label="Password"
            name="password"
            value={this.state.password}
            onChange={(password) => {
              this.setState({ password });
            }}
            onKeyPress={this.handleKeyPress}
            type="password"
          />
          <FormGroup className="mt-3">
            <Button
              text="Log In"
              onClick={() => {
                this.submitLogin();
              }}
              color="primary"
            />
          </FormGroup>
        </Form>
        {platform.platform_id === 2 ? (
          <span>
            <br />
            <Alert color="info">
              If you need your login details, please contact {this.scrapeProof('support@timocco.com')}.
            </Alert>
          </span>
        ) : null}
      </Container>
    );
  }
}

const withState = connect((state) => {
  const { user } = state;
  return {
    token: user ? user.token : null,
    errorMessage: user ? user.authErrorMessage : null,
  };
});
export default withWhiteLabelContext(withRouter(withState(Login)));
